/*
==========================================
Custom main-product.liquid
==========================================
*/

//商品詳細 タブ切り替え
const changeTab = (e,_TargetId) => {
  const targetElem = document.getElementById(_TargetId);
  if(targetElem){
    document.querySelector('.c-product-description .TabList__Item.is-active').classList.remove('is-active');
    document.querySelector('.c-product-description .TabPanel.is-active').classList.remove('is-active');

    e.target.classList.add('is-active');
    targetElem.classList.add('is-active');
  }
}

//商品詳細 SPのアコーディオン開閉(タブのis-activeには触らない)
const toggleDescriptionAccordion = (e) => {
  const button = e.currentTarget;
  if(!button) return;
  const isOpen = button.getAttribute('aria-expanded') === 'true';
  button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
}

//SNAP「もっと見る」 横スクロールをやめて全件を縦に並べる(並べ替えはCSSが .is-expanded を見て行う)
//押したボタンは消えるので、続きから見られるよう7件目にフォーカスを移す。見つからなければ一覧に移す
//(LEEEPの投稿は、投稿そのものがリンクの形と、投稿の中にリンクがある形がある)
const openProductSnap = (e) => {
  const snap = e.currentTarget ? e.currentTarget.closest('.c-product-snap') : null;
  if(!snap) return;
  snap.classList.add('is-expanded');
  const post = snap.querySelectorAll('.LeeepPost:not(.LeeepEmpty)')[6];
  const link = post ? (post.matches('a') ? post : post.querySelector('a')) : null;
  const target = link || snap.querySelector('.c-product-snap__list');
  if(target) target.focus();
}

// Call Wishlist app
const callWishList = (_variant_id) => {
  alert("Call Wishlist")
}

// 購入モード切り替え
const getPurchaseMode = (_element) => {
  const productForm = _element ? _element.closest('.ProductForm') : null,
    wrapper = productForm ? productForm.querySelector('.purchase-mode-wrapper') : document.querySelector('.purchase-mode-wrapper');

  if (!wrapper) {
    return {
      mode: 'normal',
      sellingPlanId: ''
    };
  }

  const activeButton = wrapper.querySelector('.purchase-mode-btn.active');

  return {
    mode: activeButton ? activeButton.dataset.mode : 'normal',
    sellingPlanId: wrapper.dataset.sellingPlanId || ''
  };
}

const updatePurchaseButtonLabels = (_wrapper) => {
  const productForm = _wrapper.closest('.ProductForm'),
    selectedMode = _wrapper.querySelector('.purchase-mode-btn.active')?.dataset.mode || 'normal',
    addButtons = productForm ? productForm.querySelectorAll('.c-product-form__add-button:not(.button--soldout)') : [];

  addButtons.forEach(addButton => {
    if (!addButton.dataset.normalText) {
      addButton.dataset.normalText = addButton.textContent.trim();
    }

    addButton.textContent = selectedMode === 'trial' ? '自宅でお試し - ¥0' : addButton.dataset.normalText;
  });
}

//カート追加
const addVariantToCart = (_variant_id,_variant_current_qty,_variant_inventory_quantity,_selling_plan_id)=>{
  const current_qty = Number(_variant_current_qty),
    inventory_qty = Number(_variant_inventory_quantity),
    form_qty = 1;

  // if(current_qty + form_qty > inventory_qty){
  //   alert("在庫がありません。");
  //   document.getElementById(`c-add-cart--${_variant_id}`).textContent = "SOLD OUT";
  //   document.getElementById(`c-add-cart--${_variant_id}`).classList.add("button--disabled");
  //   document.getElementById(`c-add-cart--${_variant_id}`).classList.remove("button--primary");
  //   document.getElementById(`c-add-cart--${_variant_id}`).setAttribute("disabled",true);
  // }else{
    let formData = {
      items: [{
       id: Number(_variant_id),
       quantity: form_qty
       }]
     };

    if (_selling_plan_id) {
      formData.items[0].selling_plan = Number(_selling_plan_id);
    }

    const cartAddUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? `${window.Shopify.routes.root}cart/add.js`
      : '/cart/add.js';
  
    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'dataType': 'json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      if (data && typeof data.items === 'undefined') {
        alert("在庫を超えて購入できませんでした。ページを再表示します。");
        window.location.reload();
      }else{
        window.location.href = "/cart"
      }
    })
    .catch((error) => {
      alert("エラーが発生しました。ページを再表示します。");
      console.error('Error:', error);
      window.location.reload()
    });
  // }
}

// Back InStock アプリ呼び出し
const callBackInStock = ()=>{
  setTimeout(()=>{
    const backInStockBtn = document.querySelector('.BIS_trigger');
    if(backInStockBtn){
      backInStockBtn.click()
    }
  }, 100);
}

//Variant選択時
//※option：1種類で実装
const selectedVariant = (e,_elem_type)=>{
  const selectedElement = e.target.closest('[data-variant_id]');

  if (!selectedElement) {
    return;
  }

  const
    variant_id = selectedElement.dataset.variant_id,
    variant_current_qty = selectedElement.dataset.variant_current_qty,
    variant_inventory_quantity = selectedElement.dataset.variant_inventory_quantity,
    option_1 = selectedElement.dataset.option_1,
    option_2 = selectedElement.dataset.option_2,
    option_3 = selectedElement.dataset.option_3;

  if(option_1 !== ""){
    const selector_option1 = document.getElementById(option_1);
    if (selector_option1) {
      selector_option1.click();
    }
  }
  if(option_2 !== ""){
    const selector_option2 = document.getElementById(option_2);
    if (selector_option2) {
      selector_option2.click();
    }
  }
  if(option_3 !== ""){
    const selector_option3 = document.getElementById(option_3);
    if (selector_option3) {
      selector_option3.click();
    }
  }

  if(_elem_type === "purchase_btn"){
    const purchaseMode = getPurchaseMode(selectedElement),
      sellingPlanId = purchaseMode.mode === 'trial' ? purchaseMode.sellingPlanId : '';

    if (purchaseMode.mode === 'trial' && !sellingPlanId) {
      alert('無料試着の販売プランが未設定です。');
      return;
    }

    addVariantToCart(variant_id,variant_current_qty,variant_inventory_quantity,sellingPlanId)
  }else if(_elem_type === "favorite_btn"){
    callWishList(variant_id)
  }else if(_elem_type === "call_BIS"){
    // callWishlist(_variant_id)
    callBackInStock()
  }
}

// カラー画像選択時
const selectedColorOption = (e) => {
  const selected_color = e.target.dataset.selected_color,
    variant_list_elem = document.querySelectorAll('[data-list_color]');
  
  variant_list_elem.forEach(elem => {
    if(elem.dataset.list_color === selected_color){
      elem.removeAttribute('hidden');
    }else{
      elem.setAttribute('hidden',true);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.purchase-mode-wrapper').forEach(wrapper => {
    const modeButtons = wrapper.querySelectorAll('.purchase-mode-btn');

    updatePurchaseButtonLabels(wrapper);

    modeButtons.forEach(button => {
      button.addEventListener('click', () => {
        modeButtons.forEach(item => {
          const isActive = item === button;

          item.classList.toggle('active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        updatePurchaseButtonLabels(wrapper);
      });
    });
  });
});

/*
  -- 2025.2.18 Add start : Product Gallery Popup --
*/
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.Product__ActionViewGallery button').forEach(button => {
	
		button.addEventListener('click', () => {
				document.querySelector('.ProductGallery__Popup').classList.add('is-open');
		});
	});
	
	document.querySelectorAll('.ProductGallery__Popup__header .js-closePopup').forEach(button => {
		button.addEventListener('click', function() {
				this.closest('.ProductGallery__Popup').classList.remove('is-open');
		});
	});
});
/* 2025.2.18 Add end : Product Gallery Popup -- */
